import { combineReducers } from 'redux';
import searchReducer from './searchReducer';
import bukuPromosiReducer from './bukuPromosiReduces';

// We call state in here
export default combineReducers({
    search: searchReducer,
    bukuPromosi: bukuPromosiReducer,
});